module.exports = __webpack_public_path__ + "static/media/refresh.f0734bce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/refresh.svg
// module id = 581
// module chunks = 0